// extracted by mini-css-extract-plugin
export default {"modal__title":"styles_modal__title__A9q6W","modal__content":"styles_modal__content__VZhqP","modal":"styles_modal__NH9vq","modal__btns":"styles_modal__btns__lnEHA"};